
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ancestry",
      function () {
        return require("private-next-pages/ancestry.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ancestry"])
      });
    }
  